import { atom } from 'jotai'

/**
 * AdminUser is intentionally a subset of CurrentUser. The role field
 * drives the role-gate. For an admin, clientId is the identity's required
 * storage/RLS anchor, not customer membership. It is kept only as the legacy
 * convenience default for create forms; the Admin UI never displays it or
 * uses it to scope global reads.
 */
export interface AdminUser {
  /** Authenticated users.is_internal; missing values do not enable internal UI. */
  isInternal?: boolean
  id: string
  clientId: string
  email: string
  name: string
  role: 'student' | 'hr' | 'admin'
}

export const adminUserAtom = atom<AdminUser | null>(null)
